import React from "react";
import PopUpComponent from "../PopUp/PopUpComponent";
import { normalizeRoles, hasRole } from "../../util/utilFunction";
import EditLogo from "../../Assets/editLogo.png";
import "./TableListMold.css";

const TableListMold = ({
  data,
  onClick,
  onClickEdit,
  popUpDeleteProduk,
  setPopUpDeleteProduk,
  popUpEditProduk,
  setPopUpEditMold,
  setDataPickDelete,
  newTargetProduk,
  setNewTargetProduk,
  editNamaMold,
  setEditNamaMold,
  setEditColorMold,
  editColorMold,
  material,
  setMaterial,
  total,
  setTotal,
  editBerat,
  setEditBerat,
}) => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);
  const canEditTarget = hasRole(
    dataUser,
    "produksi_admin",
    "ppic_admin",
    "super_user"
  );
  const canEditMold = hasRole(dataUser, "ppic_admin", "super_user");

  const handleDeleteMold = (button, data) => {
    setDataPickDelete(data);
    if (button === "Cancel") {
      setPopUpDeleteProduk(false);
      setDataPickDelete();
    }
  };
  const handleCancel = () => {
    setPopUpEditMold(false);
    setMaterial("");
    setTotal();
  };

  const handleEditMold = (button, data) => {
    setPopUpEditMold(true);
    setDataPickDelete(data);
    setEditNamaMold(data.name);
    setEditColorMold(data.color);
    setMaterial(data.material);
    setTotal(data.total);
    setNewTargetProduk(data.targetProduk);
    setEditBerat(data.berat);
    if (button === "Cancel") {
      setPopUpEditMold(false);
    }
  };

  return (
    <div className="wrapper_table">
      {popUpDeleteProduk ? (
        <PopUpComponent>
          <p>
            Apakah Kamu yakin untuk <b>MENGHAPUS</b> Mold ini?
          </p>
          <div className="wrapper_button_submit_popup">
            <button
              className="button_popup"
              onClick={() => handleDeleteMold("Cancel")}
            >
              Cancel
            </button>
            <button className="button_popup background_red" onClick={onClick}>
              Kirim
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpEditProduk ? (
        <PopUpComponent>
          <div
            style={{ display: "flex", flexWrap: "wrap", marginBottom: "16px" }}
          >
            {canEditTarget ? (
              <>
                <div className="wrapper_input">
                  <p className="font_weight_bold">Target Per-Cavity</p>
                  <input
                    type="number"
                    className="input_jumlah"
                    placeholder="Target Harian Produk"
                    value={newTargetProduk}
                    onChange={(e) => setNewTargetProduk(e.target.value)}
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
                <div className="wrapper_input">
                  <p className="font_weight_bold">Berat Per-Cavity</p>
                  <input
                    type="number"
                    className="input_jumlah"
                    placeholder="Berat Per Cavity"
                    value={editBerat}
                    onChange={(e) => setEditBerat(e.target.value)}
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
              </>
            ) : (
              ""
            )}

            {canEditMold ? (
              <>
                <div className="wrapper_input">
                  <p className="font_weight_bold">
                    Nama Mold
                    <br />
                    (Tidak Boleh Sama)
                  </p>
                  <div className="wrapper_radio">
                    <input
                      className="input_jumlah"
                      type="text"
                      placeholder="Nama Mold"
                      value={editNamaMold}
                      onChange={(e) => setEditNamaMold(e.target.value)}
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>
                <div className="wrapper_input">
                  <p className="font_weight_bold">Warna Mold</p>
                  <div className="wrapper_radio">
                    <input
                      className="input_jumlah"
                      type="text"
                      placeholder="Warna Mold"
                      value={editColorMold}
                      onChange={(e) => setEditColorMold(e.target.value)}
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>
                <div className="wrapper_input">
                  <p className="font_weight_bold">Material</p>
                  <div className="wrapper_radio">
                    <input
                      className="input_jumlah"
                      type="text"
                      placeholder="Material"
                      value={material}
                      onChange={(e) => setMaterial(e.target.value)}
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>
                <div className="wrapper_input">
                  <p className="font_weight_bold">Total</p>
                  <div className="wrapper_radio">
                    <input
                      className="input_jumlah"
                      type="number"
                      placeholder="Total"
                      value={total}
                      onChange={(e) => setTotal(e.target.value)}
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
          <div className="wrapper_button_submit_popup">
            <button className="button_popup" onClick={() => handleCancel()}>
              Cancel
            </button>
            <button
              className="button_popup background_red"
              onClick={onClickEdit}
            >
              Kirim
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      <div style={{ overflowY: "scroll" }}>
        <table style={{ width: "100%" }}>
          <tr>
            <th
              style={{
                background: "#e8e9f8",
                padding: "12px 6px",
                width: "auto",
                fontSize: "14px",
              }}
            >
              No.
            </th>
            <th
              style={{
                background: "#e8e9f8",
                padding: "12px 6px",
                width: "auto",
                fontSize: "14px",
              }}
            >
              Mold
            </th>
            <th
              style={{
                background: "#e8e9f8",
                padding: "12px 6px",
                width: "auto",
                fontSize: "14px",
              }}
            >
              Color
            </th>
            <th
              style={{
                background: "#e8e9f8",
                padding: "12px 6px",
                width: "auto",
                fontSize: "14px",
              }}
            >
              Target Per Cavity
            </th>
            <th
              style={{
                background: "#e8e9f8",
                padding: "12px 6px",
                width: "auto",
                fontSize: "14px",
              }}
            >
              Material
            </th>
            <th
              style={{
                background: "#e8e9f8",
                padding: "12px 6px",
                width: "auto",
                fontSize: "14px",
              }}
            >
              Berat
            </th>
            <th
              style={{
                background: "#e8e9f8",
                padding: "12px 6px",
                width: "auto",
                fontSize: "14px",
              }}
            >
              Total
            </th>
            <th
              style={{
                background: "#e8e9f8",
                padding: "12px 6px",
                width: "auto",
                fontSize: "14px",
              }}
            >
              Edit
            </th>
            <th
              style={{
                background: "#e8e9f8",
                padding: "12px 6px",
                width: "auto",
                fontSize: "14px",
              }}
            >
              Delete
            </th>
          </tr>
          {data &&
            data.map((data, index) => {
              return (
                <tr
                  style={
                    index % 2 === 0
                      ? {
                          background: "white",
                          fontSize: "12px",
                        }
                      : {
                          background: "#f2f2f2",
                          fontSize: "12px",
                        }
                  }
                  key={index}
                >
                  <td
                    style={{
                      fontSize: "14px",
                      padding: "8px 0",
                      alignContent: "center",
                    }}
                  >
                    {index + 1}.
                  </td>
                  <td
                    style={{
                      fontSize: "14px",
                      padding: "8px 0",
                      alignContent: "center",
                    }}
                  >
                    {data.name}
                  </td>
                  <td
                    style={{
                      fontSize: "14px",
                      padding: "8px 0",
                      alignContent: "center",
                    }}
                  >
                    {data.color}
                  </td>
                  <td
                    style={{
                      fontSize: "14px",
                      padding: "8px 0",
                      alignContent: "center",
                    }}
                  >
                    {data.targetProduk}
                  </td>
                  <td
                    style={{
                      fontSize: "14px",
                      padding: "8px 0",
                      alignContent: "center",
                    }}
                  >
                    {data.material}
                  </td>
                  <td
                    style={{
                      fontSize: "14px",
                      padding: "8px 0",
                      alignContent: "center",
                    }}
                  >
                    {data.berat}
                  </td>
                  <td
                    style={{
                      fontSize: "14px",
                      padding: "8px 0",
                      alignContent: "center",
                    }}
                  >
                    {data.total}
                  </td>
                  <td
                    style={{
                      fontSize: "14px",
                      padding: "8px 0",
                      alignContent: "center",
                      padding: "8px 0",
                    }}
                  >
                    <img
                      className="width_edit_logo"
                      src={EditLogo}
                      onClick={() => handleEditMold("", data)}
                      alt="edit_logo"
                    />
                  </td>
                  <td
                    style={{
                      fontSize: "14px",
                      alignContent: "center",
                      padding: "8px 0",
                    }}
                  >
                    <button
                      className="button_delete_list_bahan"
                      onClick={() => {
                        setPopUpDeleteProduk(true);
                        handleDeleteMold("", data);
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })}
        </table>
      </div>
    </div>
  );
};
export default TableListMold;
